module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('lightbox-gallery', {
    staticClass: "lightbox-media-gallery",
    attrs: {
      "showing": _vm.showing,
      "index": _vm.index,
      "can-slide-past-first": _vm.canSlidePastFirst,
      "can-slide-past-last": _vm.canSlidePastLast
    },
    on: {
      "update:showing": function($event) {
        _vm.emitShowing($event)
      },
      "update:index": function($event) {
        _vm.emitIndex($event)
      },
      "close": function($event) {
        _vm.emitClose()
      },
      "slide-past-first": function($event) {
        _vm.emitSlidePastFirst()
      },
      "slide-past-last": function($event) {
        _vm.emitSlidePastLast()
      }
    }
  }, _vm._l((_vm.media), function(m) {
    return _c('lightbox-media-gallery-slide', {
      attrs: {
        "media": m
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24964ad9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/lightbox/media-gallery.vue
// module id = 1995
// module chunks = 2